import { MessageCircle } from "lucide-react";
import { useSettings } from "../hooks/useSettings";

const FloatingWhatsapp = () => {
  const { data: s } = useSettings();
  const num = (s?.whatsapp || "").replace(/[^0-9]/g, "");
  if (!num) return null;
  const href = `https://wa.me/${num}?text=${encodeURIComponent("Hi, I'm interested in a property listed on your website.")}`;
  return (
    <a href={href} target="_blank" rel="noreferrer" data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-3.5 pr-5 py-3.5 shadow-lg shadow-black/20 hover:scale-105 transition-transform">
      <MessageCircle size={22} />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsapp;
